export const environment = {
  production: false,
  baseUrl: 'https://devrequests.work.condor.solutions/psol-v1/'
};


